(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lotto/components/start/assets/react/components/start-packages.js') >= 0) return;  svs.modules.push('/modules/lotto/components/start/assets/react/components/start-packages.js');

'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const StartPackages = () => {
  const handleClick = (rows, price) => {
    svs.components.analytics.trackEvent({
      category: 'lotto_startPage',
      action: 'CTA_predefined',
      opt_label: "".concat(rows, "rader"),
      opt_value: price
    }, () => {
      svs.utils.url.navigate("lotto/fardiga-spel/".concat(price));
    });
  };
  const packages = svs.numbergames.rules.getRules(svs.numbergames.productMapping.CONSTANTS.LOTTO).PACKAGES;
  return React.createElement("div", {
    className: "start-packages"
  }, React.createElement("div", {
    className: "packages-body"
  }, React.createElement("h2", {
    className: "packages-header js-packages-header"
  }, "Vill du spela f\xE4rdiga spel?"), React.createElement("div", {
    className: "package-wrapper js-packages-wrapper"
  }, Object.entries(packages).map(_ref => {
    let _ref2 = _slicedToArray(_ref, 2),
      price = _ref2[0],
      details = _ref2[1];
    return React.createElement("div", {
      className: "package",
      key: price,
      onClick: () => handleClick(details.rows, Number(price))
    }, React.createElement("div", {
      className: "package-rows"
    }, "".concat(details.rows, " rader")), React.createElement("div", {
      className: "package-price"
    }, "".concat(price, " kr")));
  }))));
};
setGlobal('svs.lotto.react.components', {
  StartPackages
});

 })(window);